import axios from "axios"

import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "../config/authConfig";

let msalInstance:any ;
if (!msalInstance) {
  msalInstance = new PublicClientApplication(msalConfig);
   msalInstance.initialize();
}

axios.interceptors.request.use(

     async(config) =>{
        const tokenResponse = await msalInstance.acquireTokenSilent({
            scopes:[process.env.REACT_APP_API_CLIENTID],
        });   
        config.headers.Authorization = `Bearer ${tokenResponse.accessToken}`
        return config;
     },
     (error)=>{
        return Promise.reject(error);
     }


);
export default axios;